enum AiContentProjectAgentToolName {
  CreateItems = 'create-items',
  UpdateItems = 'update-items',
  GenerateAssets = 'generate-assets',
  UpdateBrief = 'update-brief',
  UpdateInputParameters = 'update-input-parameters',
  UpdateGenerationSetup = 'update-generation-setup',
}

export {AiContentProjectAgentToolName};
